import React from 'react';
import PropTypes from 'prop-types';
import Filters from './Filters.jsx';
import Tools from './Tools.jsx'

function Toolbar({
  filterProps,
  toolsProps
}) {
  return (
    <div>
      <Filters {...filterProps} />
      <Tools {...toolsProps} />
    </div>
  );
}

Toolbar.defaultProps = {};

Toolbar.propTypes = {
  filterProps: PropTypes.object,
  toolsProps: PropTypes.object
};

export default Toolbar;



// WEBPACK FOOTER //
// ./src/components/Admin/User/Toolbar/index.jsx